<template>
  <div class="sos">
    <img height="91" class="title" src="@/assets/images/zxcImg/zxcTitle1.png" />
    <p
      class="corGray"
    >美菜SOS系列指数（MCSOS’ Index）主要包含滞销指数、救援指数，以供需关系、价格波动等指标计算而成。滞销指数通过数值反馈菜品滞销严重程度，为公众及业内解决滞销问题提供数据参考。救援指数是美菜网对滞销菜品帮扶成果的评估数值，旨在引导社会关注滞销地区的经济发展，助力精准脱贫。</p>
    <div class="content">
      <div class="sos-img">
        <img height="20" width="146" src="@/assets/images/zxcImg/zxcMapTitle.png" />
        <img height="436" src="@/assets/images/zxcImg/zxcMap.png" />
      </div>
      <div class="sos-table">
        <div class="s-tabs">
          <div class="tab" @click="handlerIndex(1)" :class="{tabActive:sosIndex==1}">滞销指数</div>
          <div class="tab" @click="handlerIndex(2)" :class="{tabActive:sosIndex==2}">SOS救援指数</div>
        </div>
        <div class="timeRange">
          <div
            class="tc"
            v-for="(item,index) in timeList"
            :data-index="index"
            :key="index"
            :class="{tcActive:timeIndex==index}"
            @click="handlerTime(index)"
          >{{item.time_title}}</div>
        </div>
        <div class="tab-unsold" v-if="sosIndex==1">
          <div class="tab-bar">
            <span class="bar">菜品</span>
            <span class="bar">滞销指数</span>
            <span class="bar">排名</span>
          </div>
          <div class="tab-list">
            <div class="tab-item" v-for="(item,index) in unsoldL" :key="index">
              <div class="tab-a">
                <span>{{item.vegetable_name}}</span>
                <span>{{item.count}}</span>
                <span>{{item.ranking}}</span>
              </div>
              <div class="tab-b">
                <div class="a-bar">
                  <span>产品</span>
                  <span>省份</span>
                  <span>指数</span>
                </div>
                <div class="b-bar" v-for="(i,ind) in item.children" :key="ind">
                  <span>{{i.vegetable_name}}</span>
                  <span>{{i.region}}</span>
                  <span>{{i.count}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="tab-sos" v-else>
          <div class="tab-bar">
            <span class="bar">产品</span>
            <span class="bar">所属区域</span>
            <span class="bar">救援指数</span>
            <span class="bar">排名</span>
          </div>
          <div class="tab-list">
            <div class="tab-a" v-for="(item,index) in sosIndexL" :key="index">
              <span>{{item.vegetable_name}}</span>
              <span>{{item.region}}</span>
              <span>{{item.count}}</span>
              <span>{{item.ranking}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "sos",
  data() {
    return {
      timeList: [],
      unsoldList: [],
      sosIndexList: [],
      timeIndex: "0",
      sosIndex: "1"
    };
  },
  computed: {
    sosIndexL() {
      return this.sosIndexList[this.timeIndex]
    },
    unsoldL() {
      return this.unsoldList[this.timeIndex]
    }
  },
  methods: {
    handlerTime(id) {
      this.timeIndex = id;
    },
    handlerIndex(num) {
      this.sosIndex = num;
    },
    getSosIndexList() {
      _api.all.getSosIndexList().then(res => {
        this.sosIndexList = res.data;
        console.log(this.sosIndexList)
      });
    },
    getDateTimeList() {
      _api.all.getDateTimeList().then(res => {
        this.timeList = res.data;
      });
    },
    getUnsalabeIndexList() {
      _api.all
        .getUnsalabeIndexList()
        .then(res => {
          this.unsoldList = res.data;
        });
    }
  },
  mounted() {
    this.getDateTimeList();
    this.getUnsalabeIndexList();
    this.getSosIndexList()
  }
};
</script>

<style lang="scss" scoped>
.sos {
  font-family: "Microsoft Yahei", "Helvetica Neue", Helvetica, Arial, sans-serif;
  width: 1000px;
  margin: 30px auto 40px;
  .title {
    margin: 0 auto;
    display: block;
  }
  .content {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
  }
}
.sos-img {
  width: 50%;
  display: flex;
  flex-direction: column;
}
.sos-table {
  width: 40%;
  border: 1px solid #eee;
  .s-tabs {
    display: flex;
    border-bottom: 2px solid #60b035;
    height: 44px;
    line-height: 44px;
    cursor: pointer;
    .tab {
      width: 50%;
      color: #60b035;
      text-align: center;
    }
    .tabActive {
      color: #eee;
      background: #80bd5f;
    }
  }
  .timeRange {
    display: flex;
    color: #aaa;
    font-size: 13px;
    cursor: pointer;
    .tc {
      flex: 1;
      font-weight: bold;
      padding: 10px 0;
      text-align: center;
      border-left: 1px solid #f5f5f5;
      border-right: 1px solid #f5f5f5;
    }
    .tcActive {
      color: #80bd5f;
      position: relative;
      &::after {
        content: " ";
        height: 0;
        left: 50%;
        position: absolute;
        width: 0;
        bottom: 0px;
        margin-left: -7px;
        border: 7px solid #fff;
        border-top: none;
        border-bottom-color: #80bd5f;
      }
    }
  }
  .tab-bar {
    font-size: 13px;
    display: flex;
    justify-content: space-around;
    background-color: #f5f5f5;
    height: 30px;
    line-height: 30px;
  }
  .tab-list {
    height: 378px;
    overflow-y: auto;
    font-size: 13px;
    cursor: pointer;
    span {
      flex: 1;
    }
    .tab-item {
      &:hover .tab-b {
        display: block;
      }
      &:hover .tab-a {
        background: #e5ffed;
      }
    }
    .tab-a {
      height: 39px;
      line-height: 39px;
      display: flex;
      justify-content: space-around;
      text-align: center;
      border-bottom: 1px solid #eee;
    }
    .tab-b {
      background-color: #f5f5f5;
      display: none;
      .a-bar {
        display: flex;
        justify-content: space-around;
        text-align: center;
        color: #aaa;
        height: 29px;
        line-height: 29px;
      }
      .b-bar {
        display: flex;
        justify-content: space-around;
        text-align: center;
        color: #888;
        height: 29px;
        line-height: 29px;
      }
    }
  }
}
</style>